export default __webpack_public_path__ + "static/media/no_recommended_replacement.7f724bc7.svg";